import { 
    GET_BAG_ORDER_BY_BAG_NO,
    GET_BAG_ORDER_BY_BAG_NO_SUCCESS,
    GET_BAG_ORDER_BY_BAG_NO_FAIL,
    UPDATE_ORDERS_BY_BAG_NO,
    UPDATE_ORDERS_BY_BAG_NO_SUCCESS,
    UPDATE_ORDERS_BY_BAG_NO_FAIL,
    SAVE_BOX_SCAN_HISTORY,
    SAVE_BOX_SCAN_HISTORY_SUCCESS,
    SAVE_BOX_SCAN_HISTORY_FAIL,
    GET_BOX_SCAN_HISTORIES,
    GET_BOX_SCAN_HISTORIES_SUCCESS,
    GET_BOX_SCAN_HISTORIES_FAIL,
    GET_BOX_UPDATE_SUMMARY,
    GET_BOX_UPDATE_SUMMARY_SUCCESS,
    GET_BOX_UPDATE_SUMMARY_FAIL,
    FETCH_ORDER_INFO_BY_TRACKING_NUMBER,
    FETCH_ORDER_INFO_BY_TRACKING_NUMBER_SUCCESS,
    FETCH_ORDER_INFO_BY_TRACKING_NUMBER_FAIL,
    SCAN_TO_REMOVE,
    SCAN_TO_REMOVE_SUCCESS,
    SCAN_TO_REMOVE_FAIL,
    SCAN_WRONG_AREA,
    SCAN_WRONG_AREA_SUCCESS,
    SCAN_WRONG_AREA_FAIL,
    FETCH_ORDER_INFO_BY_UPS_ORDER_NUMBER,
    FETCH_ORDER_INFO_BY_UPS_ORDER_NUMBER_SUCCESS,
    FETCH_ORDER_INFO_BY_UPS_ORDER_NUMBER_FAIL,
    SCAN_REJECT,
    SCAN_REJECT_SUCCESS,
    SCAN_REJECT_FAIL,
    BATCH_CREATE_SECOND_DELIVERY,
    BATCH_CREATE_SECOND_DELIVERY_SUCCESS,
    BATCH_CREATE_SECOND_DELIVERY_FAIL,
    VALIDATE_BAG_NO,
    VALIDATE_BAG_NO_SUCCESS,
    VALIDATE_BAG_NO_FAIL,
    UPDATE_ORDERS_BY_TNOS,
    UPDATE_ORDERS_BY_TNOS_SUCCESS,
    UPDATE_ORDERS_BY_TNOS_FAIL,
    UPDATE_TRACKING_EXCEPTION_BY_TNO,
    UPDATE_TRACKING_EXCEPTION_BY_TNO_SUCCESS,
    UPDATE_TRACKING_EXCEPTION_BY_TNO_FAIL,
    BATCH_UPDATE_TO_GATEWAY_OUT,
    BATCH_UPDATE_TO_GATEWAY_OUT_SUCCESS,
    BATCH_UPDATE_TO_GATEWAY_OUT_FAIL
} from '../actions/types';

const initialState = {
    updateTrackingExceptionByTno: [],
    updateTrackingExceptionByTnoLoading: false,
    updateTrackingExceptionByTnoError: false,
    getBagOrderByBagNo: [],
    getBagOrderByBagNoLoading: false,
    getBagOrderByBagNoError: false,
    updateOrdersByBagNo: [],
    updateOrdersByBagNoLoading: false,
    updateOrdersByBagNoError: false,
    saveBoxScanHistory: [], 
    saveBoxScanHistoryLoading: false,
    saveBoxScanHistoryError: false,
    getBoxScanHistories: [], 
    getBoxScanHistoriesLoading: false,
    getBoxScanHistoriesError: false,
    getBoxUpdateSummary: [],
    getBoxUpdateSummaryLoading: false,
    getBoxUpdateSummaryError: false,
    updateStatusByOrder: [],
    updateStatusByOrderLoading: false,
    updateStatusByOrderError: false,
    fetchOrderInfoByTrackingNumber: [],
    fetchOrderInfoByTrackingNumberLoading: false,
    fetchOrderInfoByTrackingNumberError: false,
    scanToRemove: [],
    scanToRemoveLoading: false,
    scanToRemoveError: false,
    scanWrongArea: [],
    scanWrongAreaLoading: false,
    scanWrongAreaError: false,
    fetchOrderInfoByUpsOrderNumber: [],
    fetchOrderInfoByUpsOrderNumberLoading: false,
    fetchOrderInfoByUpsOrderNumberError: false,
    scanReject: [],
    scanRejectLoading: false,
    scanRejectError: false,
    batchCreateSecondDelivery: [],
    batchCreateSecondDeliveryLoading: false,
    batchCreateSecondDeliveryError: false,
    validateBagNo: [],
    validateBagNoLoading: false,
    validateBagNoError: false,
    updateOrdersByTnos: [],
    updateOrdersByTnosLoading: false,
    updateOrdersByTnosError: false,
    batchUpdateToGatewayOut: [],
    batchUpdateToGatewayOutLoading: false,
    batchUpdateToGatewayOutError: false,
}

export default function utReducer(state = initialState, action){
    switch(action.type){
        case BATCH_UPDATE_TO_GATEWAY_OUT:
            return {
                ...state,
                batchUpdateToGatewayOutLoading: true,
            }
        case BATCH_UPDATE_TO_GATEWAY_OUT_SUCCESS:
            return {
                ...state,
                batchUpdateToGatewayOut: action.payload,
                batchUpdateToGatewayOutLoading: false
            }
        case BATCH_UPDATE_TO_GATEWAY_OUT_FAIL:
            return {
                ...state,
                batchUpdateToGatewayOutLoading: false,
                batchUpdateToGatewayOutError: action.payload
            }
        case UPDATE_TRACKING_EXCEPTION_BY_TNO:
            return {
                ...state,
                updateTrackingExceptionByTnoLoading: true,
            }
        case UPDATE_TRACKING_EXCEPTION_BY_TNO_SUCCESS:
            return {
                ...state,
                updateTrackingExceptionByTno: action.payload,
                updateTrackingExceptionByTnoLoading: false
            }
        case UPDATE_TRACKING_EXCEPTION_BY_TNO_FAIL:
            return {
                ...state,
                updateTrackingExceptionByTnoLoading: false,
                updateTrackingExceptionByTnoError: action.payload
            }
        case UPDATE_ORDERS_BY_TNOS:
            return {
                ...state,
                updateOrdersByTnosLoading: true,
            }
        case UPDATE_ORDERS_BY_TNOS_SUCCESS:
            return {
                ...state,
                updateOrdersByTnos: action.payload,
                updateOrdersByTnosLoading: false
            }
        case UPDATE_ORDERS_BY_TNOS_FAIL:
            return {
                ...state,
                updateOrdersByTnosLoading: false,
                updateOrdersByTnosError: action.payload
            }
        case GET_BAG_ORDER_BY_BAG_NO:
            return {
                ...state,
                getBagOrderByBagNoLoading: true,
            }
        case GET_BAG_ORDER_BY_BAG_NO_SUCCESS:
            return {
                ...state,
                getBagOrderByBagNo: action.payload,
                getBagOrderByBagNoLoading: false
            }
        case GET_BAG_ORDER_BY_BAG_NO_FAIL:
            return {
                ...state,
                getBagOrderByBagNoLoading: false,
                getBagOrderByBagNoError: action.payload
            }
        case UPDATE_ORDERS_BY_BAG_NO:
            return {
                ...state,
                updateOrdersByBagNoLoading: true,
            }
        case UPDATE_ORDERS_BY_BAG_NO_SUCCESS:
            return {
                ...state,
                updateOrdersByBagNo: action.payload,
                updateOrdersByBagNoLoading: false
            }
        case UPDATE_ORDERS_BY_BAG_NO_FAIL:
            return {
                ...state,
                updateOrdersByBagNoLoading: false,
                updateOrdersByBagNoError: action.payload
            }
        case SAVE_BOX_SCAN_HISTORY:
            return {
                ...state,
                saveBoxScanHistoryLoading: true,
            }
        case SAVE_BOX_SCAN_HISTORY_SUCCESS:
            return {
                ...state,
                saveBoxScanHistory: action.payload,
                saveBoxScanHistoryLoading: false
            }
        case SAVE_BOX_SCAN_HISTORY_FAIL:
            return {
                ...state,
                saveBoxScanHistoryLoading: false,
                saveBoxScanHistoryError: action.payload
            }
        case GET_BOX_SCAN_HISTORIES:
            return {
                ...state,
                getBoxScanHistoriesLoading: true,
            }
        case GET_BOX_SCAN_HISTORIES_SUCCESS:
            return {
                ...state,
                getBoxScanHistories: action.payload,
                getBoxScanHistoriesLoading: false
            }
        case GET_BOX_SCAN_HISTORIES_FAIL:
            return {
                ...state,
                getBoxScanHistoriesLoading: false,
                getBoxScanHistoriesError: action.payload
            }
        case GET_BOX_UPDATE_SUMMARY:
            return {
                ...state,
                getBoxUpdateSummaryLoading: true,
            }
        case GET_BOX_UPDATE_SUMMARY_SUCCESS:
            return {
                ...state,
                getBoxUpdateSummary: action.payload,
                getBoxUpdateSummaryLoading: false
            }
        case GET_BOX_UPDATE_SUMMARY_FAIL:
            return {
                ...state,
                getBoxUpdateSummaryLoading: false,
                getBoxUpdateSummaryError: action.payload
            }
        case FETCH_ORDER_INFO_BY_TRACKING_NUMBER:
            return {
                ...state,
                fetchOrderInfoByTrackingNumberLoading: true,
            }
        case FETCH_ORDER_INFO_BY_TRACKING_NUMBER_SUCCESS:
            return {
                ...state,
                fetchOrderInfoByTrackingNumber: action.payload,
                fetchOrderInfoByTrackingNumberLoading: false
            }
        case FETCH_ORDER_INFO_BY_TRACKING_NUMBER_FAIL:
            return {
                ...state,
                fetchOrderInfoByTrackingNumberLoading: false,
                fetchOrderInfoByTrackingNumberError: action.payload
            }
        case SCAN_TO_REMOVE:
            return {
                ...state,
                scanToRemoveLoading: true,
            }
        case SCAN_TO_REMOVE_SUCCESS:
            return {
                ...state,
                scanToRemove: action.payload,
                scanToRemoveLoading: false
            }
        case SCAN_TO_REMOVE_FAIL:
            return {
                ...state,
                scanToRemoveLoading: false,
                scanToRemoveError: action.payload
            }
        case SCAN_WRONG_AREA:
            return {
                ...state,
                scanWrongAreaLoading: true,
            }
        case SCAN_WRONG_AREA_SUCCESS:
            return {
                ...state,
                scanWrongArea: action.payload,
                scanWrongAreaLoading: false
            }
        case SCAN_WRONG_AREA_FAIL:
            return {
                ...state,
                scanWrongAreaLoading: false,
                scanWrongAreaError: action.payload
            }
        case FETCH_ORDER_INFO_BY_UPS_ORDER_NUMBER:
            return {
                ...state,
                fetchOrderInfoByUpsOrderNumberLoading: true,
            }
        case FETCH_ORDER_INFO_BY_UPS_ORDER_NUMBER_SUCCESS:
            return {
                ...state,
                fetchOrderInfoByUpsOrderNumber: action.payload,
                fetchOrderInfoByUpsOrderNumberLoading: false
            }
        case FETCH_ORDER_INFO_BY_UPS_ORDER_NUMBER_FAIL:
            return {
                ...state,
                fetchOrderInfoByUpsOrderNumberLoading: false,
                fetchOrderInfoByUpsOrderNumberError: action.payload
            }
        case SCAN_REJECT:
            return {
                ...state,
                scanRejectLoading: true,
            }
        case SCAN_REJECT_SUCCESS:
            return {
                ...state,
                scanReject: action.payload,
                scanRejectLoading: false
            }
        case SCAN_REJECT_FAIL:
            return {
                ...state,
                scanRejectLoading: false,
                scanRejectError: action.payload
            }
        case BATCH_CREATE_SECOND_DELIVERY:
            return {
                ...state,
                batchCreateSecondDeliveryLoading: true,
            }
        case BATCH_CREATE_SECOND_DELIVERY_SUCCESS:
            return {
                ...state,
                batchCreateSecondDelivery: action.payload,
                batchCreateSecondDeliveryLoading: false
            }
        case BATCH_CREATE_SECOND_DELIVERY_FAIL:
            return {
                ...state,
                batchCreateSecondDeliveryLoading: false,
                batchCreateSecondDeliveryError: action.payload
            }
        case VALIDATE_BAG_NO:
            return {
                ...state,
                validateBagNoLoading: true,
            }
        case VALIDATE_BAG_NO_SUCCESS:
            return {
                ...state,
                validateBagNo: action.payload,
                validateBagNoLoading: false
            }
        case VALIDATE_BAG_NO_FAIL:
            return {
                ...state,
                validateBagNoLoading: false,
                validateBagNoError: action.payload
            }
        default:
            return state;
    }
}
